import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const validate = (t) => {
  return Yup.object({
    firstName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    lastName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    dateOfBirth: Yup.string()
      .required(t("required"))
      .test("DATE", t("choose-between-1930"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [curDay, curMonth, curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),
    street: Yup.string()
      .required(t("required"))
      .typeError(t("in-valid"))
      .max(50, t("max-50-characters"))
      .matches(/^[a-zA-Z-.äöüÄÖÜß ]*$/g, t("validation-p1")),
    gender: Yup.string().required(t("required")).nullable(),
    houseNumber: Yup.string()
      .required(t("required"))
      .typeError(t("in-valid"))
      .max(10, t("max-10-digits")),
    city: Yup.string()
      .required(t("required"))
      .typeError(t("in-valid"))
      .max(50, t("max-50-characters")),
    postalCode: Yup.number()
      .required(t("required"))
      .typeError(t("in-valid"))
      .positive(t("postalCode-positive"))
      .test(
        "len",
        t("max-5-characters"),
        (val) => !val || (val && val.toString().length === 5)
      ),
    phoneNumber: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .typeError(t("in-valid"))
      .test(
        "len",
        t("less-than-15"),
        (val) =>
          !val ||
          (val && val.toString().length > 3 && val.toString().length <= 15)
      )
      .required(t("required")),

    // futureCarePermissions: Yup.boolean().when(
    //   'futureCarePermissions',
    //   (futureCarePermissions, schema) => {
    //     return futureCarePermissions
    //       ? schema.oneOf([true], t('please-confirm'))
    //       : schema;
    //   }
    // ),

    // futureCarePermissions: Yup.boolean().test(
    //   'is-confirmed1',
    //   '',
    //   // '' + t('please-confirm'),
    //   (value) => value === true,
    // ),
    // // futureCareTermsOfUse: Yup.boolean().test(
    // //   'is-confirmed2',
    // //   '',
    // //   // '' + t('please-confirm'),
    // //   (value) => value === true,
    // // ),
    futureCarePermissions: Yup.boolean().test(
      "is-confirmed1",
      t("checkbox-error-message"),
      (value) => value === true
    ),

    futureCareTermsOfUse: Yup.boolean().when("futureCarePermissions", {
      is: true,
      then: Yup.boolean().oneOf([true], t("checkbox-error-message")),
      otherwise: Yup.boolean().test(
        "is-confirmed2",
        t("checkbox-error-message"),
        (value) => value === true
      ),
    }),
  });
};

export const initialValues = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  street: "",
  gender: "",
  houseNumber: "",
  city: "",
  postalCode: "",
  phoneNumber: "+49",
  futureCarePermissions: false,
  futureCareTermsOfUse: false,
};
